import React from 'react'
import { Sparkles } from 'lucide-react'

interface LoadingOverlayProps {
  isOpen: boolean
  message: string
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ isOpen, message }) => {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-md z-[9999] flex flex-col items-center justify-center select-none cursor-wait animate-in fade-in duration-300">
      <div className="relative flex flex-col items-center p-8 rounded-2xl border border-white/10 bg-slate-900/60 backdrop-blur-xl shadow-2xl max-w-sm w-full mx-4 text-center animate-in zoom-in-95 duration-300">
        {/* Glow effect */}
        <div className="absolute inset-0 -z-10 rounded-2xl bg-gradient-to-tr from-primary/20 via-transparent to-info/20 blur-xl opacity-75" />
        
        {/* Rotating gradient ring */}
        <div className="relative w-16 h-16 mb-6">
          <div className="absolute inset-0 rounded-full border-4 border-white/5" />
          <div className="absolute inset-0 rounded-full border-4 border-t-primary border-r-info animate-spin" />
          <div className="absolute inset-0 flex items-center justify-center text-primary animate-pulse">
            <Sparkles className="h-6 w-6" />
          </div>
        </div>

        {/* Loading text */}
        <h3 className="text-lg font-bold text-white mb-2">Please Wait</h3>
        <p className="text-sm text-text-secondary leading-relaxed">{message}</p>
      </div>
    </div>
  )
}
